/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 *
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 *
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */

/*
 * --------------------------------------------------------------------------------
 * This file contains a hook that proxies a hook from 
 * online-patient-management-reducers making less types required to use the hook.
 * --------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * Imports - External
 * ---------------------------------------------------------------------------------
 */

/**
 * Required to make use of JSX functionality
 */
import * as React from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
/*
 * ---------------------------------------------------------------------------------
 * Imports - Internal
 * ---------------------------------------------------------------------------------
 */





import FieldContext from '../../context/FieldContext';

import FormTypeContext from '../../context/FormTypeContext';

import Skeleton from '@material-ui/lab/Skeleton';

/*
 * ---------------------------------------------------------------------------------
 * Interfaces
 * ---------------------------------------------------------------------------------
 */
interface IOpmsFieldLabel {
    name?: string;
    bold?: boolean;
}

/*
 * ---------------------------------------------------------------------------------
 * Styles
 * ---------------------------------------------------------------------------------
 */

const useStyles = makeStyles<Theme, IOpmsFieldLabel>(theme => ({
    text: {
        fontWeight: props => props.bold === true ? 'bold' : undefined
    }
}));


/*
 * ---------------------------------------------------------------------------------
 * components
 * ---------------------------------------------------------------------------------
 */

const OpmsFieldLabel: React.FunctionComponent<IOpmsFieldLabel> = ({
    name,
    bold,
    children
}) => {
    const classes = useStyles({ bold });

    const fieldName = React.useContext(FieldContext);

    const formType = React.useContext(FormTypeContext);

    const label = React.useMemo(() => {
        const property = formType?.properties?.find(p => p.propertyName === (name ?? fieldName));

        return property?.label

    }, [formType, fieldName, name])

    const [skeletonWidth] = React.useState((Math.random() * 85) + 15)

    return (
        <Typography
            className={classes.text}
        >
            {
                label ?? (
                    <Skeleton width={`${skeletonWidth}%`} />
                )
            }
        </Typography>
    )
}

/*
 * ---------------------------------------------------------------------------------
 * Default Export
 * ---------------------------------------------------------------------------------
 */

export default OpmsFieldLabel;
